
<ng-template #template let-anchor>
  <span>Test o rama</span>
</ng-template>

<div class="row top10" *ngIf="filter">
  <div class="col-xs-12">
    <div class="row no-gutters">
      <div class="col-xs-1">
        Name:
      </div>
      <div class="col-xs-11 ganttheader">
        <span *ngFor="let day of filter.dateRange.days; first as isFirst"
              [ngStyle]="{'width':100/filter.dateRange.days.length+'%','display':'inline-block'}">
          <span *ngIf="filter.selectedView == schViews.day" style="width:100%;display:inline-block">
            <span *ngFor="let hour of hoursInDay" style="width:4.166%;display:inline-block">
              {{ '| ' + hour }}
            </span>
          </span>
          <span *ngIf="filter.selectedView == schViews.month"
                (click)="ganttDateClick.emit(genDr(vt.day,day))">
            {{ day.format('M/D') }}
          </span>
          <span *ngIf="(filter.selectedView == schViews.threeMonths &&
        (isFirst
        || day.isSame(m(filter.dateRange.days[0]).add(1,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(2,'month'),'day')))"
                (click)="ganttDateClick.emit(genDr(vt.ganttAndDetail,day))">
            {{ day.format('MMMM')}}
          </span>
          <span *ngIf="(filter.selectedView == schViews.year &&
        (isFirst
        || day.isSame(m(filter.dateRange.days[0]).add(1,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(2,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(3,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(4,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(5,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(6,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(7,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(8,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(9,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(10,'month'),'day')
        || day.isSame(m(filter.dateRange.days[0]).add(11,'month'),'day')))"
                (click)="ganttDateClick.emit(genDr(vt.ganttAndDetail,day))">
            {{ day.format('MMM')}}
          </span>
          <span *ngIf="filter.selectedView == schViews.week || filter.selectedView == schViews.twoWeeks"
                (click)="ganttDateClick.emit(genDr(vt.day,day))">
            {{ day.format('ddd M/D')}}
          </span>
        </span>
      </div>
    </div>
    <div class="row no-gutters" *ngFor="let person of peopleScheduled | async; trackBy: trackByPerson">
      <div class="col-xs-1 ganttday"
           (click)="nameSelected.emit(person.name)">
        {{person.name}}
      </div>
      <div class="col-xs-11">
        <span *ngFor="let s of person.schedule; trackBy: trackBySch"
              [ngClass]="s.classes"
              [ngStyle]="{'background-color': s.color, 'width':s.widthPercent}"
              (click)="showSchedule(person, s)"
              [attr.title]="s.hoverDescription">
          <ng-container [ngTemplateOutlet]="s.siteCode != '' ? scheduleItemTemplate : s.siteCode == '' && s.icon !='' ? updatingTemplate : fillGapTemplate"
                        [ngTemplateOutletContext]="{s:s}"></ng-container>
        </span>
      </div>
    </div>
  </div>
</div>

<ng-template #scheduleItemTemplate let-s="s">
  <!--<i *ngIf="s.isVip && s.scheduleItemStatusId != siStatus.pending" class="far fa-handshake"></i>
  <i *ngIf="s.scheduleItemStatusId != siStatus.pending" [attr.class]="s.icon"></i>-->
  {{ s.ganttDescription }}
</ng-template>

<ng-template #updatingTemplate>
  <i class="fas fa-sync fa-spin"></i> Updating...
</ng-template>

<ng-template #fillGapTemplate>
  Fill Gap
</ng-template>

<aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
